import { AxiosClient } from "redux/AxiosClient";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addCurriculumContentAsync = createAsyncThunk(
  "admin/addCurriculumContent",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addCurriculumContent`, payload, toolkit);
  }
);

export const getAllCurriculumContentAsync = createAsyncThunk(
  "admin/getAllCurriculumContent",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllCurriculumContent?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}&status=${payload.status || ""}`,
      [],
      toolkit
    );
  }
);

export const getCurriculumContentByIdAsync = createAsyncThunk(
  "admin/getCurriculumContent",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getCurriculumContent/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateCurriculumContentByIdAsync = createAsyncThunk(
  "admin//updateCurriculumContentById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateCurriculumContentById`,
      payload,
      toolkit
    );
  }
);

export const updateCurriculumContentStatusAsync = createAsyncThunk(
  "admin/updateCurriculumContentStatus",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateCurriculumContentStatus`,
      payload,
      toolkit
    );
  }
);

export const masterCurriculumByPackageIdAsync = createAsyncThunk(
  "admin/masterCurriculumByPackageId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/masterCurriculumByPackageId?packageId=${payload.packageId || ""}`,
      [],
      toolkit
    );
  }
);

export const deleteStudyMaterialAsync = createAsyncThunk(
  "admin/deleteStudyMaterial",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteStudyMaterial/${payload}`,
      [],
      toolkit
    );
  }
);

export const uploadCurriculumAsync = createAsyncThunk(
  "admin/uploadCurriculum",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/uploadCurriculum`, payload, toolkit);
  }
);

export const getCurriculumFilesAsync = createAsyncThunk(
  "admin/getAllBulkFiles",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllBulkFiles?page=${payload.page}&limit=${payload.limit}&fileType=curriculum`,
      [],
      toolkit
    );
  }
);
